export const VIDIO_CHAT_HOST = process.env.NEW_VIDIO_CHAT_HOST
export const VIDIO_CHAT_SECURE = process.env.VIDIO_CHAT_SECURE
export const PNS_PUBLIC_WEB_API_HOST = process.env.PNS_PUBLIC_WEB_API_BASE_URL
export const HERMES_HOST = process.env.HERMES_HOST || "https://hermes.vidio.com"